import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import type { VacationApprovalDecisionKind } from '../../../models/vacationApproval.types';
import { CARD_LABELS } from '../vacationApprovalCard.definitions';

interface ApprovalCardActionsProps {
    onDecide: (kind: VacationApprovalDecisionKind) => void;
}

export function ApprovalCardActions({ onDecide }: ApprovalCardActionsProps) {
    return (
        <footer className="mt-auto flex gap-2">
            <button
                type="button"
                onClick={() => onDecide('reject')}
                className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-red-200 px-3 py-2.5 text-sm font-semibold text-red-700 transition-colors hover:bg-red-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 font-montserrat"
            >
                <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                {CARD_LABELS.reject}
            </button>
            <button
                type="button"
                onClick={() => onDecide('approve')}
                className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-primary-500 px-3 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 font-montserrat"
            >
                <CheckIcon className="h-4 w-4" aria-hidden="true" />
                {CARD_LABELS.approve}
            </button>
        </footer>
    );
}
